import { render, staticRenderFns } from "./OneRowTitle.vue?vue&type=template&id=4c1a97db&scoped=true"
import script from "./OneRowTitle.vue?vue&type=script&lang=js"
export * from "./OneRowTitle.vue?vue&type=script&lang=js"
import style0 from "./OneRowTitle.vue?vue&type=style&index=0&id=4c1a97db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_dshyztwqotzq6hkhxg56wcmkza/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a97db",
  null
  
)

export default component.exports